module.exports = __webpack_public_path__ + "img/image_ot-brazil-vitoria_tanks6_1920px.bcb82198.jpg";